export const GET_ALL_DATA = "GET_ALL_DATA";
export const GET_LANG = "GET_LANG";
export const GET_JSON = "GET_JSON";
export const SET_JSON = "SET_JSON";
